jQuery(document).ready(function ($) {
	var STORAGE_KEY = 'localmedia_site_popup_dismissed';
	var $popup = $('#site-popup');

	if (!$popup.length) {
		return;
	}

	if (sessionStorage.getItem(STORAGE_KEY)) {
		return;
	}

	var $closeTriggers = $popup.find('[data-site-popup-close]');
	var $closeButton = $popup.find('.site-popup__close');

	function openPopup() {
		$popup.removeClass('hidden').removeAttr('hidden').attr('aria-hidden', 'false');
		$('body').addClass('site-popup-open');
		$closeButton.trigger('focus');
	}

	function closePopup() {
		sessionStorage.setItem(STORAGE_KEY, '1');
		$popup.addClass('hidden').attr('hidden', true).attr('aria-hidden', 'true');
		$('body').removeClass('site-popup-open');
	}

	$closeTriggers.on('click', function (e) {
		e.preventDefault();
		closePopup();
	});

	$(document).on('keydown.sitePopup', function (e) {
		if (e.key === 'Escape' && !$popup.hasClass('hidden')) {
			closePopup();
		}
	});

	setTimeout(openPopup, 10000);
});
